module.exports = __webpack_public_path__ + "media/images/prediction/special/nagai_hiratsuka/bg_nagaitop-d87ed5be403e3e8f51d2ea4bff4d5ddd.jpg";